import React from 'react';
import { useSelector } from 'react-redux';

// API
import { deleteAccount } from 'Shared/api/user';

// Hooks
import { useToggle } from 'Shared/utils/hooks';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

// Utils
import { handleLaunchExternalLink } from 'Shared/utils/external-link';

// Helpers
import { showNotificationError } from 'Shared/helpers';

// Components
import WpAlert from 'Wpds/components/alert/WpAlert';
import { WpModal, WpModalBody, WpModalHeader, WpModalFooter } from 'Wpds/components/modal';
import { WpButton } from 'Wpds/components/button';
import ConfirmModal from 'Shared/components/ConfirmModal/ConfirmModal';

// Constants
import ExternalLinksConstants from 'Shared/constants/ExternalLinks.constants';

// Styles
import './DeleteAccountButton.scss';

function DeleteAccountButton() {
  const [isGuardDeleteModalOpen, toggleGuardDeleteModal] = useToggle(false);
  const { user: currentUser } = useCurrentUser();
  const isPaidPlan = useSelector(state => state.organization.billingState).includes('paid');
  const billingContact = useSelector(state => state.organization.billingContact);

  const disableDeleteAccount = currentUser.id == billingContact.id && isPaidPlan;
  const [showConfirmModal, toggleShowConfirmModal] = useToggle(false);

  const { isPiUser } = useCurrentUser();

  const handleDeleteAccount = () => {
    deleteAccount()
      .then(response => {
        if (response?.data?.redirect_url) window.location.href = response.data.redirect_url;
        else window.location.reload();
      })
      .catch(error => {
        showNotificationError(error);
      });
  };

  const handleDeleteMyAccountButtonClick = () => {
    if (disableDeleteAccount) {
      toggleGuardDeleteModal();
    } else {
      toggleShowConfirmModal();
    }
  };

  const handleContactSupportClick = () => {
    handleLaunchExternalLink({ href: ExternalLinksConstants.contact_us });
  };

  if (isPiUser) return null;
  return (
    <>
      {showConfirmModal && (
        <ConfirmModal
          message="Are you sure you want to delete your account?"
          isOpen
          onToggle={toggleShowConfirmModal}
          onConfirmClick={handleDeleteAccount}
          confirmButtonLabel="Delete"
        />
      )}
      <button
        type="button"
        className="delete-account-button btn btn-link pl-0"
        onClick={handleDeleteMyAccountButtonClick}
      >
        Delete my account
      </button>
      {disableDeleteAccount && (
        <WpModal size="sm" isOpen={isGuardDeleteModalOpen} onToggle={toggleGuardDeleteModal}>
          <WpModalHeader />
          <WpModalBody>
            <WpAlert type="info">
              Your organization has an active subscription. Please contact support to handle this request.
            </WpAlert>
            <div className="disable-delete-account-modal-body">
              <WpButton onClick={handleContactSupportClick} variant="tertiary">
                Contact Support
              </WpButton>
            </div>
          </WpModalBody>
          <WpModalFooter>
            <WpButton variant="tertiary" onClick={toggleGuardDeleteModal}>
              Close
            </WpButton>
          </WpModalFooter>
        </WpModal>
      )}
    </>
  );
}

export default DeleteAccountButton;
